import React, { useState } from "react";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";
function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}
function getComparator(order, orderBy) {
	return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
const headCells = [
	{
		id: "streetLine1",
		numeric: false,
		disablePadding: false,
		label: "Address Line 1",
	},
	{
		id: "streetLine2",
		numeric: false,
		disablePadding: false,
		label: "Address Line 2",
	},
	{
		id: "city",
		numeric: false,
		disablePadding: false,
		label: "City",
	},
	{
		id: "province",
		numeric: false,
		disablePadding: false,
		label: "Province / State",
	},
	{
		id: "postalCode",
		numeric: false,
		disablePadding: false,
		label: "Postal / Zip Code",
	},
	{
		id: "country",
		numeric: false,
		disablePadding: false,
		label: "Country",
	},
	{
		id: "dateMoveIn",
		numeric: false,
		disablePadding: false,
		label: "Move In",
	},
	{
		id: "dateMoveOut",
		numeric: false,
		disablePadding: false,
		label: "Move Out",
	},
];
export default function AddressInformationTable(props) {
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("calories");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const { rows, removeAddress, editAddress } = props;
	const { t } = useTranslation();
	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		backgroundColor: "#ebebeb",
		whiteSpace: "nowrap",
		// "&:nth-of-type(even)": {
		// 	backgroundColor: theme.palette.action.hover,
		// },
	}));
	return (
		<React.Fragment>
			<Box sx={{ width: "100%" }}>
				<Paper sx={{ width: "100%", mb: 2, borderRadius: "8px" }}>
					<TableContainer sx={{ borderRadius: "inherit" }}>
						<Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"medium"}>
							<EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={rows.length} />
							<TableBody>
								{/* stableSort(rows, getComparator(order, orderBy)) */}
								{rows.length > 0 ? (
									rows
										.slice()
										.sort(getComparator(order, orderBy))
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											return (
												<StyledTableRow tabIndex={-1} key={index}>
													<TableCell>
														<div>
															<IconButton
																color="primary"
																onClick={() => {
																	editAddress(index);
																}}
															>
																<EditIcon />
															</IconButton>
															<IconButton
																color="secondary"
																onClick={() => {
																	removeAddress(index);
																}}
															>
																<DeleteForeverIcon />
															</IconButton>
														</div>
													</TableCell>
													<TableCell>{row.streetLine1}</TableCell>
													<TableCell>{row.streetLine2}</TableCell>
													<TableCell>{row.city}</TableCell>
													<TableCell>{row.province}</TableCell>
													<TableCell>{row.postalCode}</TableCell>
													<TableCell>{row.country}</TableCell>
													<TableCell>{moment.utc(row.dateMoveIn).format("MMM DD YYYY")}</TableCell>
													<TableCell>{row.dateMoveOut ? moment.utc(row.dateMoveOut).format("MMM DD YYYY") : ""}</TableCell>
												</StyledTableRow>
											);
										})
								) : (
									<TableRow>
										<TableCell colSpan={8} align="center">
											Please add an address
										</TableCell>
									</TableRow>
								)}
								{/* {emptyRows > 0 && (
									<TableRow
										style={{
											height: 53 * emptyRows,
										}}
									>
										<TableCell colSpan={6} />
									</TableRow>
								)} */}
							</TableBody>
						</Table>
					</TableContainer>
					{/* <TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={rows.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/> */}
				</Paper>
			</Box>
		</React.Fragment>
	);
}
function EnhancedTableHead(props) {
	const { t } = useTranslation();
	const { order, orderBy, onRequestSort } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};
	const StyledTableHead = styled(TableHead)(({ theme }) => ({
		backgroundColor: theme.palette.primary.faded,
		color: theme.palette.primary.main,
		fontWeight: "bold",
	}));
	return (
		<StyledTableHead>
			<TableRow>
				<TableCell></TableCell>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{ color: "inherit", fontWeight: "inherit", whiteSpace: "nowrap" }}
					>
						<TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : "asc"} onClick={createSortHandler(headCell.id)}>
							{t(headCell.label)}
							{orderBy === headCell.id ? (
								<Box component="span" sx={visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</StyledTableHead>
	);
}
